import { LOADS } from "constants/actionTypes";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { deserializeLoads } from "lib/serializers/loads";
import reduceReducers from "reduce-reducers";

const fetch = apiModelOfflineFetchReducer(LOADS, {
  deserializer: deserializeLoads,
  clearOnRequest: false,
});

const loadsReducer = reduceReducers(fetch);

export default loadsReducer;
